import { Route, Routes } from "react-router-dom"
import ForgotPassword from "./modules/auth/ForgotPassword/ForgotPassword";
import Login from "./modules/auth/Login/Login";
import Otp from "./modules/auth/Otp/Otp";
import ResetPassword from "./modules/auth/resetpassword/ResetPassword";
import ResendEmail from "./modules/auth/resendEmail/ResendEmail";
import CommentsOnIncident from "./modules/commentsOnIncident";
const PublicPage = () => {
    return (
        <>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgotPassword" element={<ForgotPassword />} />
                <Route path="/otp" element={<Otp />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/resendEmail" element={<ResendEmail />} />
                <Route path="/commentsOnIncident" element={<CommentsOnIncident />} />
            </Routes>
        </>
    )
}

export default PublicPage;